export default __webpack_public_path__ + "static/mexico-flag-146e031e198c4d3acd13b07f804a54e5.svg";